import { auth } from '@onevision-resources/login';
import { useApolloClient } from '@provision/graphql-client';
import { portalPaths } from '@provision/portal-routes';
import { useCallback } from 'react';
import { wsEventBus } from 'src/core/realtime-connection';
import { useGlobalStore } from 'src/store';
import { useNavigateRoute } from 'src/utils/routing';

export const useLogout = () => {
  const { navigate } = useNavigateRoute();
  const setSelectedPartnerId = useGlobalStore.use.setSelectedPartnerId();
  const setMultiTenancyMode = useGlobalStore.use.setMultiTenancyMode();

  const client = useApolloClient();

  const logout = useCallback(async () => {
    setSelectedPartnerId(null);
    setMultiTenancyMode(false);
    wsEventBus.disconnect();
    await auth.signOut();
    navigate(portalPaths.root());
    setTimeout(() => {
      // When user logs out, we need to clear Apollo cache to make sure that next user doesn't see
      // any cached data.
      // But clearing cache immediately doesn't work because redirect to login page doesn't
      // finish yet, and some active queries are refetched, so we wait for a second.
      void client.clearStore();
    }, 1000);
  }, [navigate, setSelectedPartnerId, setMultiTenancyMode, client]);

  return {
    logout,
  };
};
